import React from 'react'
import RecruitmentListTable from './components/RecruitmentListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const RecruitmentList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Recruitment List</HeadingOne>
                    <AddItemBtn url="add-recruitment" title="Create Recruitment" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <RecruitmentListTable />
            </div>
        </PageBody>
    );
};

export default RecruitmentList;
